import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Radio,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    message,
    Tabs,
    Calendar,
    Badge
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import {
    AimOutlined,
    AlertOutlined,
    ApartmentOutlined,
    AppstoreAddOutlined,
    AppstoreOutlined,
    PlusSquareOutlined,
    PlusOutlined,
    PullRequestOutlined,
    BarChartOutlined,
    ProjectOutlined,
    BuildOutlined,
    BankOutlined,
    UserSwitchOutlined,
    FileDoneOutlined,
    DatabaseOutlined,
    ContainerOutlined
} from '@ant-design/icons'
import { Line, Column } from '@ant-design/charts';

import moment from 'moment';
import { list } from 'postcss';

const { Option, OptGroup } = Select;
export default class shouye extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                date1: moment().startOf('year').format('YYYY'),
                date2: moment().startOf('year').format('YYYY'),
                date3: moment().startOf('year').format('YYYY'),
                date6: moment().startOf('year').format('YYYY'),
            },
            list: [],
            tableloading: false,
            list2: [],
            tableloading2: false,
            list3: [],
            tableloading3: false,
            list6: [],
            tableloading6: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {
        this.props.NAV_CHANGE2('/sjtj')
        this.props.NAV_CHANGE('/sjtj', ['数据统计'])
        this.getdata(1)
        this.getdata(2)
        this.getdata(3)
        this.getdata(6)
    }

    getdata(type, year = moment().startOf('year').format('YYYY')) {
        let that = this
        let arr = {}
        arr.type = type
        if (year) {
            arr.year = year
        }
        if (type == '1') {
            that.setState({
                tableloading: true
            })
        }
        if (type == '2') {
            that.setState({
                tableloading2: true
            })
        }
        if (type == '3') {
            that.setState({
                tableloading3: true
            })
        }
        if (type == '6') {
            that.setState({
                tableloading6: true
            })
        }
        fetch('/Shouye/shuju', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (type == '1') {
                    that.setState({
                        list: data.datalist ? data.datalist : [],
                        tableloading: false
                    })
                }
                if (type == '2') {
                    that.setState({
                        list2: data.datalist ? data.datalist : [],
                        tableloading2: false
                    })
                }
                if (type == '3') {
                    that.setState({
                        list3: data.datalist ? data.datalist : [],
                        tableloading3: false
                    })
                }
                if (type == '6') {
                    that.setState({
                        list6: data.datalist ? data.datalist : [],
                        tableloading6: false
                    })
                }

            })
    }

    render() {
        const columns = [
            {
                title: '月份',
                dataIndex: 'month',
                key: 'month',
                // width: 120,
            },
            {
                title: '面积统计',
                dataIndex: 'area',
                key: 'area',
                // width: 150,
                children: [
                    {
                        title: '已租面积(m²)',
                        dataIndex: 'area1',
                        key: 'area1',
                        // width: 150,
                    },
                    {
                        title: '待租面积(m²)',
                        dataIndex: 'area2',
                        key: 'area2',
                        // width: 150,
                    },
                    {
                        title: '出租率',
                        dataIndex: 'area3',
                        key: 'area3',
                        // width: 150,
                    },
                ]
            },
            {
                title: '企业统计',
                dataIndex: 'company',
                key: 'company',
                // width: 150,
                children: [
                    {
                        title: '全部企业',
                        dataIndex: 'company1',
                        key: 'company1',
                        // width: 150,
                    },
                    {
                        title: '新招企业',
                        dataIndex: 'company2',
                        key: 'company2',
                        // width: 150,
                    },
                    {
                        title: '到期企业',
                        dataIndex: 'company3',
                        key: 'company3',
                        // width: 150,
                    },
                    {
                        title: '解除企业',
                        dataIndex: 'company4',
                        key: 'company4',
                        // width: 150,
                    },
                ]
            },
            {
                title: '合同统计',
                dataIndex: 'contract',
                key: 'contract',
                // width: 150,
                children: [
                    {
                        title: '全部合同',
                        dataIndex: 'contract1',
                        key: 'contract1',
                        // width: 150,
                    },
                    {
                        title: '新租合同',
                        dataIndex: 'contract2',
                        key: 'contract2',
                        // width: 150,
                    },
                    {
                        title: '到期合同',
                        dataIndex: 'contract3',
                        key: 'contract3',
                        // width: 150,
                    },
                    {
                        title: '解除合同',
                        dataIndex: 'contract4',
                        key: 'contract4',
                        // width: 150,
                    },
                ]
            },
        ]
        let { tableloading, tableloading2, tableloading3, tableloading6 } = this.state
        return (<>
            <div className={'tongji2'}>
                <div className={'box'}>
                    <div className={'title'}>
                        <div className={'p1'}>创意产业园</div>
                        <div className={'p2'}>
                            <DatePicker className="input" placeholder="请选择"
                                onChange={(date, dateString) => {
                                    this.setState({
                                        condition: {
                                            ...this.state.condition,
                                            date1: dateString
                                        }
                                    })
                                    this.getdata('1', dateString)
                                }}
                                disabledDate={(current) => current > moment().endOf('year')}
                                picker="year"
                                value={this.state.condition.date1 ? moment(this.state.condition.date1) : null}
                            />
                        </div>
                    </div>
                    <Table
                        bordered
                        columns={columns}
                        dataSource={this.state.list}
                        pagination={false}
                        loading={tableloading}
                        className='table'
                        // scroll={{ x: 2150 }}
                        style={{ width: '100%' }}
                    />
                </div>
                <div className={'box'}>
                    <div className={'title'}>
                        <div className={'p1'}>检测认证园</div>
                        <div className={'p2'}>
                            <DatePicker className="input" placeholder="请选择"
                                onChange={(date, dateString) => {
                                    this.setState({
                                        condition: {
                                            ...this.state.condition,
                                            date2: dateString
                                        }
                                    })
                                    this.getdata('2', dateString)
                                }}
                                disabledDate={(current) => current > moment().endOf('year')}
                                picker="year"
                                value={this.state.condition.date2 ? moment(this.state.condition.date2) : null}
                            />
                        </div>
                    </div>
                    <Table
                        bordered
                        columns={columns}
                        dataSource={this.state.list2}
                        pagination={false}
                        loading={tableloading2}
                        className='table'
                        // scroll={{ x: 2150 }}
                        style={{ width: '100%' }}
                    />
                </div>
                <div className={'box'}>
                    <div className={'title'}>
                        <div className={'p1'}>人工智能园</div>
                        <div className={'p2'}>
                            <DatePicker className="input" placeholder="请选择"
                                onChange={(date, dateString) => {
                                    this.setState({
                                        condition: {
                                            ...this.state.condition,
                                            date3: dateString
                                        }
                                    })
                                    this.getdata('3', dateString)
                                }}
                                disabledDate={(current) => current > moment().endOf('year')}
                                picker="year"
                                value={this.state.condition.date3 ? moment(this.state.condition.date3) : null}
                            />
                        </div>
                    </div>
                    <Table
                        bordered
                        columns={columns}
                        dataSource={this.state.list3}
                        pagination={false}
                        loading={tableloading3}
                        className='table'
                        // scroll={{ x: 2150 }}
                        style={{ width: '100%' }}
                    />
                </div>
                <div className={'box'}>
                    <div className={'title'}>
                        <div className={'p1'}>别墅</div>
                        <div className={'p2'}>
                            <DatePicker className="input" placeholder="请选择"
                                onChange={(date, dateString) => {
                                    this.setState({
                                        condition: {
                                            ...this.state.condition,
                                            date6: dateString
                                        }
                                    })
                                    this.getdata('4', dateString)
                                }}
                                disabledDate={(current) => current > moment().endOf('year')}
                                picker="year"
                                value={this.state.condition.date6 ? moment(this.state.condition.date6) : null}
                            />
                        </div>
                    </div>
                    <Table
                        bordered
                        columns={columns}
                        dataSource={this.state.list6}
                        pagination={false}
                        loading={tableloading6}
                        className='table'
                        // scroll={{ x: 2150 }}
                        style={{ width: '100%' }}
                    />
                </div>
            </div>
        </>)
    }
}
